<div *ngIf="block" class="blockOverlay">
  <div class="overlay"></div>
  <div class="container">
    <div class="contentBox" *ngIf="action">
      <davinci-status-line class="status" [value]="status"></davinci-status-line>
      <h5 class="description">{{ action | translate }}</h5>
    </div>
  </div>
</div>
